package app.footyguide.web.page

import kotlinx.datetime.LocalDate

private val MONTH_LABELS_PT = mapOf(
    1 to "JAN",
    2 to "FEV",
    3 to "MAR",
    4 to "ABR",
    5 to "MAI",
    6 to "JUN",
    7 to "JUL",
    8 to "AGO",
    9 to "SET",
    10 to "OUT",
    11 to "NOV",
    12 to "DEZ",
)

fun formatSelectedDateLabel(
    date: LocalDate,
    strings: app.footyguide.core.locale.AppStrings? = null,
): String {
    val idx = date.monthNumber - 1
    val customMonths = strings?.monthsShort
    val monthLabel = if (customMonths != null && idx in customMonths.indices) {
        customMonths[idx].uppercase()
    } else {
        MONTH_LABELS_PT[date.monthNumber] ?: "M${date.monthNumber}"
    }
    return "${date.day} $monthLabel"
}
